import React, { useEffect, useState, useRef } from "react";
import Layout from "../../../components/vendorManager/Layout";
import Helmet from "react-helmet";
import Table from "../../../components/ui/Table";
import Pagination from "../../../components/ui/Pagination";
import SelectField from "../../../components/ui/form/SelectField";
import InputField from "../../../components/ui/form/InputField";
import usePaginate from "../../../hooks/api/usePaginate";
import { useSelector } from "react-redux";
import apiRequest from "../../../utils/vendorManager/apiRequest";
import { Link } from "react-router-dom";
import { PRODUCT_BY_EXCEL } from "../../../routes/vendorManager/vendorRoutes";

const MenuPricing = () => {


  const [search, setSearch] = useState("");
  const debounceRef = useRef(null);

  const {
    data: imports,
    setFilters: setImportFilters,
    setPage: setImportPage,
    currentPage,
    limit,
    loading,
    data,
    error,
    totalPages,
    totalItems,
    setPage,
    setSorting,
    sort,
  } = usePaginate({ apiMethod: apiRequest.getExcelImportList, dataKey: "imports" });


  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      const f = {};
      if (search) f.excelName = { $regex: search.trim(), $options: "i" };
      setImportFilters(f);
    }, 350);
    return () => clearTimeout(debounceRef.current);
  }, [search]);



  return (
    <Layout>
      <Helmet>
        <title>Excel Imports</title>
      </Helmet>

      <div className="p-4 bg-white rounded">
        <div className="grid grid-cols-1 sm:grid-cols-[1fr_120px] gap-2 mb-3">
          <InputField placeholder="Search by excel name..." value={search} onChange={(e) => setSearch(e.target.value)} />
          <button className="py-1 text-white rounded bg-emerald-600 hover:bg-emerald-800" onClick={() => { setSearch("") }}>
            Clear
          </button>
        </div>



        <Table
          headers={[
            { label: "Excel Name", key: "excelName", sorting: true },
            { label: "Admin Corporate Head", key: "admin", sorting: true },
            { label: "Admin tower", key: "admintower", sorting: true },
            { label: "Company Name", key: "supervendor", sorting: true },
            { label: "Vendor Manager", key: "vendormanager", sorting: true },
            { label: "Inserted", key: "inserted", sorting: true },
            { label: "Updated", key: "updated", sorting: true },
            { label: "Created", key: "createdAt", sorting: true },
            { label: "Action", key: "action", sorting: false },
          ]}
          loading={loading}
          handleSort={() => { }}
          sort={{}}
          error={error}
          cols={5}
          renderRow={
            <tbody className="bg-white divide-y divide-gray-200">
              {(imports || []).map(imp => (
                <tr key={imp._id} className="hover:bg-gray-50">
                  <td className="px-3 py-3">{imp.excelName}</td>
                  <td className="px-3 py-3 capitalize">{imp?.adminId?.name}</td>
                  <td className="px-3 py-3 capitalize">{imp?.corporateAdminId?.name}</td>
                  <td className="px-3 py-3 capitalize">{imp?.vendorId?.name}</td>
                  <td className="px-3 py-3 capitalize">{imp?.vendorManagerId?.name}</td>
                  <td className="px-3 py-3">{imp.inserted}</td>
                  <td className="px-3 py-3">{imp.updated}</td>
                  <td className="px-3 py-3">{new Date(imp.createdAt).toLocaleDateString()}</td>
                  <td className="px-3 py-3">
                    <Link to={PRODUCT_BY_EXCEL(imp._id)} className="px-3 py-1 bg-blue-600 text-white rounded">View</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          }
        />

        {totalPages > 1 && (
          <Pagination
            pagination={{
              currentPage,
              totalPages,
              totalItems: totalItems,
              perPage: limit,
            }}
            handlePageChange={setPage}
            loading={loading}
          />
        )}

      </div>
    </Layout>
  );
};

export default MenuPricing;
